import { useEffect, useState } from "react";


import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import PropTypes from "prop-types";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import { visuallyHidden } from "@mui/utils";
import EditIcon from "@mui/icons-material/Edit";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {
  Avatar,
  Grid,
  Drawer,
  Select,
  MenuItem,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  FormControl,
  InputLabel,
  FormLabel,
  RadioGroup,
  Radio,
  DialogActions,
  Stack,
  Popover,
  TextField,
  Container,
  Modal,
  
} from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Link } from "react-router-dom";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";

import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import TaskIcon from "@mui/icons-material/Task";
import InternData2 from "./InternData";
import InternStdDetail from "./InternStdDetail";
import PersonIcon from "@mui/icons-material/Person";
import { updateStudentSupervisor } from "../api/crud";
import { useDispatch, useSelector } from "react-redux";
import { updateSnackbar } from "../redux/action/dataAction";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import CancelIcon from "@mui/icons-material/Cancel";
import { blue, pink } from "@mui/material/colors";
import Chip from "@mui/material/Chip";
import {
  convertDateToString,
  dateDiff,
  timeRemain,
  timeSince,
} from "../utils/function";

import ReactExport from "react-data-export";
import FiberManualRecordOutlinedIcon from "@mui/icons-material/FiberManualRecordOutlined";
import Divider from "@mui/material/Divider";
import {
  GrDocumentPdf,
  GrDocumentText,
  GrLocation,
  GrFormClose,
  GrCopy,
} from "react-icons/gr";
import { MdExpandMore } from "react-icons/md";
import { SiGooglemaps } from "react-icons/si";
import { FcInfo } from "react-icons/fc";
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import InfoIcon from "@mui/icons-material/Info";
import MapIcon from "@mui/icons-material/Map";
import { Assignment, Padding } from "@mui/icons-material";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { current } from "@reduxjs/toolkit";

import AddIcon from '@mui/icons-material/Add';
import { engApi } from "../api/engApi";
import { addAssessmentCompanyByStId } from "../api/crud";
import { useForm as hookForm } from "react-hook-form";
import { addAssessmentCompanyCoopByStId, addAssessmentReportCoopByStId } from "../api/crud";
import BulkInputModal from "./BulkInputModal";
import SingleEvaluationModal from "./SingleEvaluationModal";






const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;






function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    headCells,
    tableData,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  
  const [copySuccess, setCopySuccess] = useState('');

// Inside EnhancedTableHead component
const handleCopy = async (headCell, tableData) => {
  try {
    let copyText = '';
    let validRowCount = 0;
    
    // Map header to the correct field names in the data based on headcells
    const fieldMap = {
      'intern_location': 'internDetailMark',
      'logbook': 'logbookscore',
      'assessment_visit': 'totalAssignment_visit',
      'assessment_present': 'totalAssignment_present',
      'assessment_supervisor': 'assessment_company_total'
    };

    const labelMap = {
      'intern_location': 'Location Score',
      'logbook': 'Logbook Score',
      'assessment_visit': 'Visit Score',
      'assessment_present': 'Presentation Score',
      'assessment_supervisor': 'Supervisor Score',
      'total': 'Total Score'
    };

    const columnKey = headCell.id;
    
    // Add data rows without header
    tableData.forEach(row => {
      let value;
      
      // Special handling for total column
      if (columnKey === 'total') {
        // Calculate total from all scores
        value = [
          row.internDetailMark || 0,
          row.logbookscore || 0,
          row.totalAssignment_visit || 0,
          row.totalAssignment_present || 0,
          row.assessment_company_total || 0
        ].reduce((sum, val) => sum + (Number(val) || 0), 0);
      } else {
        // For other columns, use the field mapping
        const mappedKey = fieldMap[columnKey] || columnKey;
        value = row[mappedKey];
      }

      // Only process and add to copyText if value exists and is not 0
      if (value && value !== 0) {
        const studentId = row.st_id?.toString().padStart(8, '0');
        
        // Format number
        if (typeof value === 'number') {
          value = value < 10 ? value.toFixed(2) : value.toFixed(1);
        }
        
        copyText += `${studentId}\t${value}\n`;
        validRowCount++;
      }
    });

    // Only proceed with copy if there's data to copy
    if (validRowCount > 0) {
      await navigator.clipboard.writeText(copyText);
      setCopySuccess(`✓ คัดลอกแล้ว ${validRowCount} รายการของ ${labelMap[columnKey] || 'คะแนน'}`);
    } else {
      setCopySuccess('ไม่มีข้อมูลให้คัดลอก');
    }
    
    setTimeout(() => setCopySuccess(''), 2000);
  } catch (err) {
    console.error('Failed to copy:', err);
    setCopySuccess('❌ คัดลอกไม่สำเร็จ - โปรดลองใหม่อีกครั้ง');
    setTimeout(() => setCopySuccess(''), 2000);
  }
};

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell,index) => (
          <TableCell
            key={headCell.id}
            // align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{border: '1px solid #ccc' , textAlign: 'center', backgroundColor: 'transparent',
              fontWeight: 'bold', color: '#333', padding: '5px',
              '&:hover': {
                backgroundColor: 'rgba(74, 144, 226, 0.05)',
              }

            }}
          >
            {index <4  && index > 0 ? (
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              sx={{ whiteSpace: "nowrap" }}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>) : (
                <Box justifyItems={'center'}  >

                  {headCell.label}
                <br />
                {index !== 0 && ( 
                    <Tooltip
                      title={
                        <div style={{ fontSize: '12px', padding: '5px' }}>
                          {copySuccess || (
                            <>
                              คลิกเพื่อคัดลอกรหัสนิสิตและ {headCell.label}
                              <br />
                              <small style={{ opacity: 0.8 }}>
                                รูปแบบ: รหัสนิสิต [tab] คะแนน
                              </small>
                            </>
                          )}
                        </div>
                      }
                      placement="top"
                      arrow
                    >
                      <IconButton
                        onClick={() => handleCopy(headCell, tableData)}
                        sx={{
                          fontWeight: 'bold',
                          fontSize: '12px',
                          color: '#4a90e2',
                          '& svg': {
                            color: '#4a90e2',
                          },
                          '&:hover': {
                            backgroundColor: 'rgba(74, 144, 226, 0.1)',
                          },
                        }}
                      >
                        <GrCopy />
                      </IconButton>
                    </Tooltip>
                  )}
              </Box>
            )}



          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

// Helper function to count scores
const calculateScoreStats = (data) => {
  const stats = {
    location: { hasScore: 0, noScore: 0 },
    logbook: { hasScore: 0, noScore: 0 },
    visit: { hasScore: 0, noScore: 0 },
    present: { hasScore: 0, noScore: 0 },
    supervisor: { hasScore: 0, noScore: 0 },
    overall: { hasScore: 0, noScore: 0 }
  };

  data.forEach(row => {
    // Location score
    if (parseFloat(row?.internDetailMark || 0) > 0) {
      stats.location.hasScore++;
    } else {
      stats.location.noScore++;
    }

    // Logbook score
    if (parseFloat(row?.logbookscore || 0) > 0) {
      stats.logbook.hasScore++;
    } else {
      stats.logbook.noScore++;
    }

    // Visit score
    if (parseFloat(row?.totalAssignment_visit || 0) > 0) {
      stats.visit.hasScore++;
    } else {
      stats.visit.noScore++;
    }

    // Present score
    if (parseFloat(row?.totalAssignment_present || 0) > 0) {
      stats.present.hasScore++;
    } else {
      stats.present.noScore++;
    }

    // Supervisor score
    if (parseFloat(row?.assessment_company_total || 0) > 0) {
      stats.supervisor.hasScore++;
    } else {
      stats.supervisor.noScore++;
    }

    // Overall (has any score)
    const hasAnyScore = parseFloat(row?.internDetailMark || 0) > 0 ||
                       parseFloat(row?.logbookscore || 0) > 0 ||
                       parseFloat(row?.totalAssignment_visit || 0) > 0 ||
                       parseFloat(row?.totalAssignment_present || 0) > 0 ||
                       parseFloat(row?.assessment_company_total || 0) > 0;
    
    if (hasAnyScore) {
      stats.overall.hasScore++;
    } else {
      stats.overall.noScore++;
    }
  });

  return stats;
};

function EnhancedTableToolbar(props) {
  const { numSelected, excelDataSet, searchCompnent, textActive, percentages, rowsFilter, onBulkInput, scoreFilter, onScoreFilter } = props;
  const totalPercentage = Object.values(percentages).reduce((acc, curr) => acc + Number(curr), 0);
  const scoreStats = calculateScoreStats(rowsFilter || []);

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity
            ),
        }),
        display: "block",
        py: 1,
      }}
    >        <Box 
          display="flex" 
          alignItems="center" 
          justifyContent="space-between"
          sx={{
            background: 'none',
            borderRadius: '12px 12px 0 0',
            padding: '16px 20px',
            color: 'inherit',
            boxShadow: 'none'
          }}
        >
          <Box display="flex" alignItems="center" gap={2}>
            {numSelected > 0 ? (
              <Box display="flex" alignItems="center" gap={1}>
                <Box 
                  sx={{
                    backgroundColor: 'rgba(74, 144, 226, 0.1)',
                    borderRadius: '20px',
                    padding: '4px 12px',
                    fontSize: '14px',
                    fontWeight: 600,
                    color: '#4a90e2'
                  }}
                >
                  {numSelected} selected
                </Box>
              </Box>
            ) : (
              <Box display="flex" alignItems="center" gap={2}>
                
                <Typography 
                  variant="h6" 
                  id="tableTitle" 
                  component="div"
                  sx={{
                    fontFamily: 'TH Sarabun New, Arial, sans-serif',
                    fontWeight: 600,
                    fontSize: '18px',
                    color: '#333'
                  }}
                >
                  รายชื่อนิสิต {textActive}
                  <Box 
                    component="span" 
                    sx={{ 
                      fontWeight: 400, 
                      fontSize: '14px', 
                      color: '#666',
                      marginLeft: '8px',
                      marginRight: '20px',
                    }}
                  >
                    ({rowsFilter.length} รายการ)
                  </Box>
                  
                  <ExcelFile
                    element={
                      <Tooltip title={`ดาวน์โหลดข้อมูลเป็น Excel (${rowsFilter?.length || 0} รายการ)`}>
                        <IconButton
                          sx={{
                            backgroundColor: 'rgba(74, 144, 226, 0.1)',
                            color: '#4a90e2',
                            '&:hover': {
                              backgroundColor: 'rgba(74, 144, 226, 0.2)',
                            }
                          }}
                        >
                          <SimCardDownloadIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </Tooltip>
                    }
                    filename="internship ENGBUU"
                  >
                    <ExcelSheet data={excelDataSet} name="internship">
                      <ExcelColumn label="Request Id" value="req_id" />
                      <ExcelColumn label="รหัสนิสิต" value="st_id" />
                      <ExcelColumn label="ชื่อ - สกุล" value="name" />
                      <ExcelColumn label="สาขาวิชา" value="branch" />
                      <ExcelColumn label="สถานประกอบการ" value="company" />
                      <ExcelColumn label={`แจ้งที่ตั้ง (${percentages?.intern_location}%)`} value="internDetailMark" />
                      <ExcelColumn label={`Logbook (${percentages?.logbook}%)`} value="logbookscore" />
                      <ExcelColumn label={`อ.นิเทศ (${percentages?.assessment_visit}%)`} value="totalAssignment_visit" />
                      <ExcelColumn label={`รายงาน (${percentages?.assessment_present}%)`} value="totalAssignment_present" />
                      <ExcelColumn label={`พี่เลี้ยง (${percentages?.assessment_supervisor}%)`} value="assessment_company" />
                      <ExcelColumn label={`คะแนนรวม (${totalPercentage}%)`} value="total" />
                    </ExcelSheet>
                  </ExcelFile>

                  {/* Bulk Input Buttons */}
                  <Tooltip title="เพิ่มคะแนนพี่เลี้ยงแบบกลุ่ม">
                    <IconButton
                      onClick={() => onBulkInput('company')}
                      sx={{
                        backgroundColor: 'rgba(76, 175, 80, 0.1)',
                        color: '#4caf50',
                        '&:hover': {
                          backgroundColor: 'rgba(76, 175, 80, 0.2)',
                        },
                        marginLeft: 1
                      }}
                    >
                      <AddIcon sx={{ fontSize: 16 }} />
                    </IconButton>
                  </Tooltip>
                  
                
                  <Box 
                    component="div" 
                    sx={{ 
                      marginTop: '8px',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '8px'
                    }}
                  >
                    
                    
                    {/* สถิติแยกตามหมวด - การ์ด */}
                    <Box sx={{ 
                      display: 'flex', 
                      gap: '8px', 
                      flexWrap: 'wrap'
                    }}>
                      {[
                        { label: '📍 แจ้งที่ตั้ง', stats: scoreStats.location, key: 'location' },
                        { label: '📖 Logbook', stats: scoreStats.logbook, key: 'logbook' },
                        { label: '👨‍🏫 อ.นิเทศ', stats: scoreStats.visit, key: 'visit' },
                        { label: '📄 รายงาน', stats: scoreStats.present, key: 'present' },
                        { label: '👔 พี่เลี้ยง', stats: scoreStats.supervisor, key: 'supervisor' }
                      ].map(({ label, stats, key }) => {
                        // แสดงจำนวนคนที่มีและไม่มีคะแนน
                        const withScoreCount = stats.hasScore;
                        const noScoreCount = stats.noScore;
                        const percentage = ((noScoreCount / (rowsFilter.length || 1)) * 100);
                        // สีแดงสำหรับคนที่ยังไม่มีคะแนน ยิ่งเปอร์เซ็นต์สูงยิ่งแดง
                        const baseColor = percentage >= 50 ? '#f44336' : percentage >= 20 ? '#ff9800' : '#4caf50';
                        const isActive = scoreFilter === key;
                        
                        return (
                          <Box
                            key={key}
                            onClick={() => onScoreFilter(key)}
                            sx={{
                              cursor: 'pointer',
                              backgroundColor: isActive ? baseColor : `${baseColor}15`,
                              color: isActive ? 'white' : baseColor,
                              borderRadius: '6px',
                              padding: '4px 8px',
                              fontSize: '11px',
                              fontWeight: isActive ? 600 : 500,
                              border: `1px solid ${baseColor}${isActive ? 'FF' : '40'}`,
                              transition: 'all 0.2s ease',
                              minWidth: 'fit-content',
                              textAlign: 'center',
                              position: 'relative',
                              '&:hover': {
                                backgroundColor: isActive ? baseColor : `${baseColor}25`,
                                transform: 'translateY(-1px)',
                                boxShadow: `0 2px 6px ${baseColor}30`,
                                borderColor: `${baseColor}60`
                              },
                              '&:active': {
                                transform: 'translateY(0px)',
                                boxShadow: `0 1px 3px ${baseColor}40`
                              },
                              // เพิ่ม indicator สำหรับสถานะ active
                              '&::before': isActive ? {
                                content: '""',
                                position: 'absolute',
                                top: '-2px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                width: '4px',
                                height: '4px',
                                backgroundColor: 'white',
                                borderRadius: '50%',
                                boxShadow: `0 0 4px ${baseColor}`
                              } : {}
                            }}
                          >
                            {label}: {withScoreCount}/{rowsFilter.length} ({((withScoreCount / (rowsFilter.length || 1)) * 100).toFixed(0)}%)
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
                </Typography>
              </Box>
            )}

           
            
            
          </Box>

          <Box 
            sx={{
              backgroundColor: 'rgba(74, 144, 226, 0.1)',
              borderRadius: '8px',
              padding: '8px 12px'
            }}
          >
            {searchCompnent}
          </Box>
        </Box>
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function InternRequestTable({
  tableData = [],
  tableColumn = [],
  allStaff = [],
  excelDataSet = [],
  percentages = [],
  textActive,
  onRefresh, // เพิ่ม callback สำหรับ refresh ข้อมูล
}) {
  const profile = useSelector((state) => state.profileReducer.profile);
  const dispatch = useDispatch();
  const isMobile = useMediaQuery('(max-width:767px)');
  const { handleSubmit, register} = hookForm;

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("calories");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [studentSelected, setStudentSelected] = useState(null);
  const [studentSupervisorSelected, setStudentSupervisorSelected] =
    useState(null);
  const [supervisorSelected, setSupervisorSelected] = useState(null);
  const [supervisorRemoveSelected, setSupervisorRemoveSelected] =
    useState(null);

  const [supervisorSelfAssign, setSupervisorSelfAssign] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [scoreFilter, setScoreFilter] = useState(null); // เพิ่ม state สำหรับกรองตามคะแนน
  const rows = tableData;
  const [rowsFilter, setRowsFilter] = useState([]);

  const headCells = tableColumn;

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRowData, setSelectedRowData] = useState(null);




  const handleOpenPopover = (event, rowData) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowData(rowData);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
    setSelectedRowData(null); // Clear selected row data
  };

  const [reportAnchorEl, setReportAnchorEl] = useState(null);
  const [selectedReportData, setSelectedReportData] = useState(null);
  
  const handleOpenReportPopover = (event, rowData) => {
    setReportAnchorEl(event.currentTarget);
    setSelectedReportData(rowData);
  };

  const handleCloseReportPopover = () => {
    setReportAnchorEl(null);
    setSelectedReportData(null); // Clear selected report data
  };

  const reportOpen = Boolean(reportAnchorEl);
  const reportId = reportOpen ? 'report-popover' : undefined;

  


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };



  const intt = () => {
    setRowsFilter(rows);
    setSearchTerm("");
    setScoreFilter(null); // รีเซ็ตตัวกรอง
  };

  // ฟังก์ชันสำหรับกรองข้อมูลตามหมวดคะแนน
  const handleScoreFilter = (filterType) => {
    if (scoreFilter === filterType) {
      // ถ้าคลิกการ์ดเดิมซ้ำ ให้ยกเลิกการกรอง
      setScoreFilter(null);
      setRowsFilter(rows);
      return;
    }

    setScoreFilter(filterType);
    let filtered = [...rows];

    switch (filterType) {
      case 'location':
        filtered = rows.filter(row => parseFloat(row?.internDetailMark || 0) === 0);
        break;
      case 'logbook':
        filtered = rows.filter(row => parseFloat(row?.logbookscore || 0) === 0);
        break;
      case 'visit':
        filtered = rows.filter(row => parseFloat(row?.totalAssignment_visit || 0) === 0);
        break;
      case 'present':
        filtered = rows.filter(row => parseFloat(row?.totalAssignment_present || 0) === 0);
        break;
      case 'supervisor':
        filtered = rows.filter(row => parseFloat(row?.assessment_company_total || 0) === 0);
        break;
      case 'hasScore':
        filtered = rows.filter(row => {
          const hasAnyScore = parseFloat(row?.internDetailMark || 0) > 0 ||
                             parseFloat(row?.logbookscore || 0) > 0 ||
                             parseFloat(row?.totalAssignment_visit || 0) > 0 ||
                             parseFloat(row?.totalAssignment_present || 0) > 0 ||
                             parseFloat(row?.assessment_company_total || 0) > 0;
          return hasAnyScore;
        });
        break;
      case 'noScore':
        filtered = rows.filter(row => {
          const hasAnyScore = parseFloat(row?.internDetailMark || 0) > 0 ||
                             parseFloat(row?.logbookscore || 0) > 0 ||
                             parseFloat(row?.totalAssignment_visit || 0) > 0 ||
                             parseFloat(row?.totalAssignment_present || 0) > 0 ||
                             parseFloat(row?.assessment_company_total || 0) > 0;
          return !hasAnyScore;
        });
        break;
      default:
        break;
    }

    // ถ้ามีการค้นหาอยู่ ให้กรองต่อ
    if (searchTerm) {
      filtered = filtered.filter((row) => {
        return (
          row.req_id.toString().toLowerCase().includes(searchTerm) ||
          row.st_id.toString().toLowerCase().includes(searchTerm) ||
          row.name.toLowerCase().includes(searchTerm) ||
          row.company.toLowerCase().includes(searchTerm) ||
          row.addressIntern.toLowerCase().includes(searchTerm)
        );
      });
    }

    setRowsFilter(filtered);
  };

  const [totalScore, setTotalScore] = useState('');
  const [total, setTotal] = useState('200');
  const [total2, setTotal2] = useState('100');

  const [evaluator, setEvaluator] = useState('');
  const [internCharacteristics, setInternCharacteristics] = useState('');
  const [internRecommendations, setInternRecommendations] = useState('');
  const [knowledgeBeforeInternship, setKnowledgeBeforeInternship] = useState('');
  const [evaluationDateTime, setEvaluationDateTime] = useState('');


   // State to control the visibility of the modal
   const [openModal1, setOpenModal1] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);

  const [openModal2, setOpenModal2] = useState(false);
  const [selectedItemId2, setSelectedItemId2] = useState(null);
  
  // Bulk input modal states
  const [openBulkModal, setOpenBulkModal] = useState(false);
  const [bulkInputData, setBulkInputData] = useState('');
  const [bulkInputType, setBulkInputType] = useState('company'); // 'company' or 'report'

  // Single evaluation modal states
  const [openSingleModal, setOpenSingleModal] = useState(false);
  const [selectedStudentData, setSelectedStudentData] = useState(null);


   const handleOpenModal = (itemId) => {
    setSelectedItemId(itemId);
    setOpenModal1(true);
  };

  const handleCloseModal = () => {
    setTotalScore('');
    setTotal('100');
    setEvaluator('');
    setInternCharacteristics('');
    setInternRecommendations('');
    setKnowledgeBeforeInternship('');
    setEvaluationDateTime('');
    setOpenModal1(false);
    setSelectedItemId(null); // Reset selected item
  };

  
  const handleOpenModal2 = (itemId) => {
    setSelectedItemId2(itemId);
    setOpenModal2(true);
  };

  const handleCloseModal2 = () => {
    setTotalScore('');
    setTotal2('200');
    setEvaluator('');
    setInternRecommendations('');
    setEvaluationDateTime('');
    setOpenModal2(false);
    setSelectedItemId2(null); // Reset selected item
  };

  // Bulk modal handlers
  const handleOpenBulkModal = (type) => {
    setBulkInputType(type);
    setOpenBulkModal(true);
  };

  const handleCloseBulkModal = () => {
    setBulkInputData('');
    setOpenBulkModal(false);
  };

  // Single evaluation modal handlers
  const handleOpenSingleModal = (rowData) => {
    setSelectedStudentData(rowData);
    setOpenSingleModal(true);
  };

  const handleCloseSingleModal = () => {
    setSelectedStudentData(null);
    setOpenSingleModal(false);
  };

  function formatDateToYYYYMMDDHHMMSS(date) {
    const pad = (num) => (num < 10 ? '0' + num : num);
    return date.getFullYear() + '-' +
           pad(date.getMonth() + 1) + '-' +
           pad(date.getDate()) + ' ' +
           pad(date.getHours()) + ':' +
           pad(date.getMinutes()) + ':' +
           pad(date.getSeconds());
  }

  const handleSubmit1 = async (event) => {
    event.preventDefault();
    
    const formData = {
      req_id: selectedItemId?.row?.req_id,
      totalScore,
      total,
      evaluator,
      internCharacteristics,
      knowledgeBeforeInternship,
      internRecommendations,
      evaluationDateTime
    };

    try {
      await addAssessmentCompanyCoopByStId(formData);
      dispatch(updateSnackbar({
        snackbarOpen: true,
        snackbarType: "success",
        snackbarMessage: "บันทึกข้อมูลสำเร็จ"
      }));
      setTimeout(async () => {
        try {
          if (onRefresh) {
            await onRefresh(); // ใช้ callback แทน reload
          } else {
            window.location.reload(); // fallback สำหรับกรณีที่ไม่มี callback
            return; // ไม่ต้องปิด modal เพราะจะ reload
          }
          handleCloseModal(); // ปิด modal หลังจาก refresh เสร็จ
        } catch (error) {
          console.error('Error during refresh:', error);
          handleCloseModal(); // ถ้า refresh ไม่สำเร็จ ก็ยังปิด modal
        }
      }, 1000);
    } catch (error) {
      dispatch(updateSnackbar({
        snackbarOpen: true,
        snackbarType: "error",
        snackbarMessage: "เกิดข้อผิดพลาดในการบันทึกข้อมูล"
      }));
      handleCloseModal(); // ปิด modal เมื่อเกิด error
    }
  };

  const handleSubmit2 = async (event) => {
    event.preventDefault();
    
    const formData = {
      req_id: selectedItemId2?.row?.req_id,
      totalScore,
      total: total2,
      evaluator,
      internRecommendations,
      evaluationDateTime
    };

    try {
      await addAssessmentReportCoopByStId(formData);
      dispatch(updateSnackbar({
        snackbarOpen: true,
        snackbarType: "success",
        snackbarMessage: "บันทึกข้อมูลสำเร็จ"
      }));
      setTimeout(async () => {
        try {
          if (onRefresh) {
            await onRefresh(); // ใช้ callback แทน reload
          } else {
            window.location.reload(); // fallback สำหรับกรณีที่ไม่มี callback
            return; // ไม่ต้องปิด modal เพราะจะ reload
          }
          handleCloseModal2(); // ปิด modal หลังจาก refresh เสร็จ
        } catch (error) {
          console.error('Error during refresh:', error);
          handleCloseModal2(); // ถ้า refresh ไม่สำเร็จ ก็ยังปิด modal
        }
      }, 1000);
    } catch (error) {
      dispatch(updateSnackbar({
        snackbarOpen: true,
        snackbarType: "error",
        snackbarMessage: "เกิดข้อผิดพลาดในการบันทึกข้อมูล"
      }));
      handleCloseModal2(); // ปิด modal เมื่อเกิด error
    }
  };

  useEffect(() => {
    intt();

  }, [rows]);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const onHandleSearch = (ev) => {
    const { value } = ev.target;
    setSearchTerm(value);

    let baseData = rows;
    
    // ถ้ามีการกรองตามคะแนนอยู่ ให้ใช้ข้อมูลที่ถูกกรองแล้ว
    if (scoreFilter) {
      switch (scoreFilter) {
        case 'location':
          baseData = rows.filter(row => parseFloat(row?.internDetailMark || 0) === 0);
          break;
        case 'logbook':
          baseData = rows.filter(row => parseFloat(row?.logbookscore || 0) === 0);
          break;
        case 'visit':
          baseData = rows.filter(row => parseFloat(row?.totalAssignment_visit || 0) === 0);
          break;
        case 'present':
          baseData = rows.filter(row => parseFloat(row?.totalAssignment_present || 0) === 0);
          break;
        case 'supervisor':
          baseData = rows.filter(row => parseFloat(row?.assessment_company_total || 0) === 0);
          break;
        case 'hasScore':
          baseData = rows.filter(row => {
            const hasAnyScore = parseFloat(row?.internDetailMark || 0) > 0 ||
                               parseFloat(row?.logbookscore || 0) > 0 ||
                               parseFloat(row?.totalAssignment_visit || 0) > 0 ||
                               parseFloat(row?.totalAssignment_present || 0) > 0 ||
                               parseFloat(row?.assessment_company_total || 0) > 0;
            return hasAnyScore;
          });
          break;
        case 'noScore':
          baseData = rows.filter(row => {
            const hasAnyScore = parseFloat(row?.internDetailMark || 0) > 0 ||
                               parseFloat(row?.logbookscore || 0) > 0 ||
                               parseFloat(row?.totalAssignment_visit || 0) > 0 ||
                               parseFloat(row?.totalAssignment_present || 0) > 0 ||
                               parseFloat(row?.assessment_company_total || 0) > 0;
            return !hasAnyScore;
          });
          break;
      }
    }

    const filtered = baseData.filter((row) => {
      return (
       ( row.req_id.toString().toLowerCase().includes(value) ||
        row.st_id.toString().toLowerCase().includes(value) ||
        row.name.toLowerCase().includes(value) ||
        row.company.toLowerCase().includes(value) ||
        row.addressIntern.toLowerCase().includes(value)) 
      );
    });

    setRowsFilter(filtered);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n?.name);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const onHandleUpdateSupervisor = async (reqId, supervisorId, updatedby) => {
    //console.log("onHandleUpdateSupervisor");
    try {
      await updateStudentSupervisor(reqId, supervisorId, updatedby);

      dispatch(
        updateSnackbar({
          open: true,
          content: "บันทึกสำเร็จ",
        })
      );

      setStudentSupervisorSelected(null);
    } catch (err) {
      console.warn(err);
    }
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const displayDialogAdvisor = (
    <Dialog
      open={!!studentSupervisorSelected}
      onClose={() => {
        setStudentSupervisorSelected(null);
        setSupervisorSelected(null);
      }}
    >
      <DialogTitle>เลือกอาจารย์นิเทศ</DialogTitle>
      <DialogContent sx={{ width: "500px" }}>
        <Grid container>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <FormLabel id="supervisor-group-label">อาจารย์นิเทศ</FormLabel>
              <RadioGroup
                onChange={(ev) => setSupervisorSelected(ev.target.value)}
                value={supervisorSelected}
                aria-labelledby="supervisor-group-label"
                // defaultValue="female"
                name="radio-buttons-group"
              >
                {allStaff
                  .filter(
                    (staff) =>
                      staff?.b_id == studentSupervisorSelected?.b_id ||
                      (studentSupervisorSelected?.b_id == 7 && staff?.b_id == 4)
                  )
                  .map((item) => {
                    return (
                      <Box display="flex" justifyContent="space-between">
                        <FormControlLabel
                          value={item.id}
                          control={<Radio />}
                          label={`${item?.name}`}
                        />

                        <Tooltip
                          title={
                            <div>
                              {item.internOwn.map((el, elIndex) => {
                                if(el?.internStudent?.name != null){
                                  const count = count+1;
                                return <div>{el?.internStudent?.name}</div>;
                                }
                              })}
                            </div>
                          }
                          placement="right"
                        >
                          <Button sx={{ color: "black" }}>
                            <HowToRegIcon />{" "}
                            <span>{item.internOwn.length} คน</span>
                          </Button>
                        </Tooltip>
                      </Box>
                    );
                  })}

                <FormControlLabel
                  value=""
                  control={<Radio />}
                  label="ยังไม่เลือก"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Stack direction="row">
          <Button
            disabled={!(supervisorSelected !== null)}
            onClick={() => {
              onHandleUpdateSupervisor(
                studentSupervisorSelected.req_id,
                supervisorSelected,
                profile?.id
              );
            }}
          >
            บันทึก
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );

  const displayDialogDelete = (
    <Dialog
      open={!!supervisorRemoveSelected}
      onClose={() => {
        setSupervisorRemoveSelected(null);
      }}
    >
      <DialogTitle id="alert-dialog-title">ยกเลิกการนิเทศ</DialogTitle>

      <DialogActions>
        <Button
          onClick={() => {
            setSupervisorRemoveSelected(null);
          }}
        >
          กลับ
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            onHandleUpdateSupervisor(
              supervisorRemoveSelected.req_id,
              "",
              profile?.id
            );
          }}
          autoFocus
        >
          ยืนยัน
        </Button>
      </DialogActions>
    </Dialog>
  );

  const displayDialogAssign = (
    <Dialog
      open={!!supervisorSelfAssign}
      onClose={() => {
        setSupervisorSelfAssign(null);
      }}
    >
      <DialogTitle id="alert-dialog-title">ยืนยันเลือกนิสิต</DialogTitle>

      <DialogActions>
        <Button
          onClick={() => {
            setSupervisorSelfAssign(null);
          }}
        >
          กลับ
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            onHandleUpdateSupervisor(
              supervisorSelfAssign.req_id,
              profile.id,
              profile?.id
            );
          }}
          autoFocus
        >
          ยืนยัน
        </Button>
      </DialogActions>
    </Dialog>
  );

  

  return (
    <>
      {displayDialogAdvisor}
      {displayDialogDelete}
      {displayDialogAssign}

      <Drawer
        anchor="right"
        open={studentSelected ? true : false}
       
        onClose={() => {
          setStudentSelected(null)
          
        }}
        
      >
        <div
          className="card-body shadow-lg"
          style={{ width: "100vw", maxWidth: "600px" }}
        >
          <div className="row g-0">
            <div className="col-12 mb-4">
              <Box display="flex" justifyContent="flex-end">
             
              <Button
                onClick={() => {
                  setStudentSelected(null);
                }}
                startIcon={<CloseIcon />}
              >
                { isMobile ? 'Close' :''}
              </Button>
              </Box>

              <InternStdDetail internRequestId={studentSelected?.req_id} />

              <Divider />
              {/* add back button */}
              { isMobile &&(
              <Box display="flex" justifyContent="flex-start">
                <Button
                  onClick={() => {
                    setStudentSelected(null);
                  }}
                  startIcon={<ArrowBackIcon />}
                >
                  { isMobile ? 'BACK' :''}
                </Button>
              </Box>)}

            </div>
            {/* <div className="col-12 ">
              <InternData2 st_id={studentSelected?.st_id} />
            </div> */}
          </div>

          <hr />
          {/* <ActivityLog /> */}
        </div>
      </Drawer>

      
        <Paper 
          sx={{ 
            width: "100%",
            borderRadius: '12px',
            overflow: 'hidden',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            border: '1px solid rgba(107, 122, 138, 0.2)'
          }}
        >
          <EnhancedTableToolbar
            numSelected={selected.length}
            excelDataSet={excelDataSet}
            textActive={textActive}
            percentages={percentages}
            rowsFilter={rowsFilter}
            onBulkInput={handleOpenBulkModal}
            scoreFilter={scoreFilter}
            onScoreFilter={handleScoreFilter}
            searchCompnent={
              <Stack spacing={1}>
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', minWidth: '400px' }}>
                  <TextField
                    size="small"
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon 
                            fontSize="small" 
                            sx={{ color: '#4a90e2' }}
                          />
                        </InputAdornment>
                      ),
                      sx: {
                        backgroundColor: 'rgba(74, 144, 226, 0.05)',
                        borderRadius: '8px',
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'rgba(74, 144, 226, 0.3)',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'rgba(74, 144, 226, 0.5)',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#4a90e2',
                        },
                        '& input': {
                          color: '#333',
                          fontSize: '14px'
                        }
                      }
                    }}
                    InputLabelProps={{
                      sx: {
                        color: '#4a90e2',
                        '&.Mui-focused': {
                          color: '#4a90e2'
                        }
                      }
                    }}
                    value={searchTerm}
                    onChange={onHandleSearch}
                    label="ค้นหานิสิต"
                    placeholder="รหัสนิสิต, ชื่อ, บริษัท..."
                    sx={{ flex: 1, minWidth: '350px' }}
                  />
                  
                  {/* ปุ่มรีเซ็ตการกรอง */}
                  {(searchTerm || scoreFilter) && (
                    <Tooltip title="ยกเลิกการกรองทั้งหมด">
                      <IconButton
                        onClick={() => {
                          setSearchTerm('');
                          setScoreFilter(null);
                          setRowsFilter(rows);
                        }}
                        sx={{
                          backgroundColor: 'rgba(244, 67, 54, 0.1)',
                          color: '#f44336',
                          '&:hover': {
                            backgroundColor: 'rgba(244, 67, 54, 0.2)',
                          }
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}
                </Box>
                
                {(searchTerm || scoreFilter) && (
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#666',
                      fontSize: '12px',
                      fontFamily: 'TH Sarabun New, Arial, sans-serif'
                    }}
                  >
                    🔍 ค้นพบ {rowsFilter.length ?? 0} รายการ
                    {scoreFilter && (
                      <Box component="span" sx={{ color: '#4a90e2', marginLeft: '4px' }}>
                        {scoreFilter === 'hasScore' && '(มีคะแนนแล้ว)'}
                        {scoreFilter === 'noScore' && '(ยังไม่มีคะแนน)'}
                        {scoreFilter === 'location' && '(ยังไม่มีคะแนนแจ้งที่ตั้ง)'}
                        {scoreFilter === 'logbook' && '(ยังไม่มีคะแนน Logbook)'}
                        {scoreFilter === 'visit' && '(อ.นิเทศยังไม่ให้ประเมิน)'}
                        {scoreFilter === 'present' && '(อ.นิเทศยังไม่ให้คะแนนรายงาน)'}
                        {scoreFilter === 'supervisor' && '(ยังไม่มีคะแนนพี่เลี้ยง)'}
                      </Box>
                    )}
                  </Typography>
                )}
              </Stack>
            }
          />
        
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClosePopover}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}

          PaperProps={{
            style: { maxWidth: '400px' }, // Set a maximum width for the Popover
          }}
        >
          <Typography sx={{ p: 2, wordWrap: 'break-word' }}>
            {selectedRowData?.assessment_visit?.comment}
          </Typography>
        </Popover>

        <Popover
          id={reportId}
          open={reportOpen}
          anchorEl={reportAnchorEl}
          onClose={handleCloseReportPopover}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          PaperProps={{
            style: { maxWidth: '400px' }, // Adjust as needed
          }}
        >
          <Typography sx={{ p: 2, wordWrap: 'break-word' }}>
            {selectedReportData?.assessment_present?.comment}
          </Typography>
        </Popover>
      
          <TableContainer sx={{
            backgroundColor: '#ffffff',
            padding: '16px',
            '& .MuiTableCell-root': {
              fontFamily: 'TH Sarabun New, Arial, sans-serif'
            }
          }}>
            <Table
              sx={{borderRadius: '10px' }}
              //aria-labelledby="tableTitle"
              //size={dense ? "small" : "medium"}
            >
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={rowsFilter.length}
                headCells={headCells}
                tableData={rowsFilter}
              />
              <TableBody>
                {stableSort(rowsFilter, getComparator(order, orderBy))
                  // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    const isItemSelected = isSelected(row?.name);
                    const labelId = `enhanced-table-checkbox-${index}`;

                    return (

                      <TableRow
                        hover
                        // onClick={(event) => handleClick(event, row.name)}
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={row.req_id}
                        selected={isItemSelected}
                        sx={{
                          backgroundColor: index % 2 === 0 ? 'rgba(74, 144, 226, 0.02)' : 'transparent',
                          '&:hover': {
                            backgroundColor: 'rgba(74, 144, 226, 0.08)',
                          }
                        }}
                      >
                        <TableCell sx={{ verticalAlign: "top", border: '1px solid #ccc' , padding: '5px', textAlign: 'center' }}>
                          {index + 1}
                        </TableCell>

                        <TableCell sx={{ verticalAlign: "top", border: '1px solid #ccc' , padding: '5px', textAlign: 'center'}}>
                          <Box 
                            onClick={() => setStudentSelected(row)}
                            role="button"
                            sx={{ 
                              cursor: 'pointer',
                              color: '#4a90e2',
                              fontWeight: 'bold',
                              '&:hover': {
                                textDecoration: 'underline',
                                color: '#2c5aa0'
                              }
                            }}
                          >
                            {row.req_id}
                          </Box>
                        </TableCell>

                        <TableCell sx={{ minWidth: 250, verticalAlign: "top", border: '1px solid #ccc' , padding: '8px'}}>
                          <Box display="flex" gap={1} alignItems="flex-start">
                            <Avatar
                              onClick={() => setStudentSelected(row)}
                              role="button"
                              alt="profile"
                              sx={{ 
                                width: 30, 
                                height: 30, 
                                cursor: 'pointer',
                                flexShrink: 0,
                                marginLeft: '4px',
                                marginRight: '4px',
                                '&:hover': {
                                  transform: 'scale(1.05)',
                                  boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
                                },
                                transition: 'all 0.2s ease'
                              }}
                              src={`https://reg.buu.ac.th/registrar/getstudentimage.asp?id=${row.st_id}`}
                            />
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <Box sx={{ fontWeight: "bold", fontSize: 12 }}>
                                {row.st_id}
                              </Box>
                              <Box sx={{ fontWeight: "bold", fontSize: 13 }}>
                                {row?.name?.split(",")[0]}
                              </Box>
                              
                              <Box sx={{ mt: 1 }}>
                                <span className="badge bg-primary" style={{ fontSize: '10px', marginRight: '4px' }}>
                                  {row?.name?.split(",")[1]}
                                </span>
                                <Tooltip title="ประเมินผลเต็มหน้า">
                                  <Link
                                    to={`/student-evaluation?req_id=${row.req_id}`}
                                    target="_blank"
                                    style={{ textDecoration: 'none', marginLeft: '4px' }}
                                  >
                                    <IconButton
                                      sx={{ height: 25, width: 25 }}
                                      size="small"
                                    >
                                      <OpenInNewIcon sx={{ fontSize: 14 }} />
                                    </IconButton>
                                  </Link>
                                </Tooltip>
                              </Box>
                              
                            </Box>
                          </Box>
                        </TableCell>

                       
                        <TableCell align="left" sx={{  border: '1px solid #ccc' , padding: '10px', textAlign: 'start'
                         }}>
                          <Box>
                          
                                
                             { row.supervisor && (
                                <Tooltip
                                  title={
                                    row.supervisor &&
                                    allStaff.length &&
                                    allStaff?.find(
                                      (staff) => staff.id === row.supervisor
                                    )?.name
                                  }
                                >
                                  <Chip
                                    label={
                                      row.supervisor &&
                                      allStaff.length &&
                                      allStaff
                                        ?.find(
                                          (staff) => staff.id === row.supervisor
                                        )
                                        ?.name.split(" ")[0]
                                    }
                                    size="small"
                                    color="default"
                                    variant='filled'
                                  />
                                </Tooltip>
                              )}
                            

                          
                          </Box>
                        </TableCell>

                   

                        <TableCell sx={{  border: '1px solid #ccc' , padding: '5px', textAlign: 'center'
                         }}> 
                            {parseFloat(row?.internDetailMark) != 0 ? (parseFloat(row?.internDetailMark)||0).toFixed(1) : "-"}
                            
                        </TableCell>

                        <TableCell sx={{  border: '1px solid #ccc' , padding: '5px', textAlign: 'center'
                         }}> 
                            {row?.logbookscore != 0 ? (row?.logbookscore.toFixed(1)) : "-"}
                        </TableCell>


                        <TableCell sx={{  border: '1px solid #ccc' , padding: '5px', textAlign: 'center'
                         }}> 
                          <Box>
                          
                          {(row?.totalAssignment_visit|| 0) != 0 ? (row?.totalAssignment_visit.toFixed(1)) : "-"}
                         
                         
                         
                          {isNaN(row?.totalAssignment_visit) ?"":
                               (
                              <IconButton
                                sx={{ height: 30, width: 30 }}
                                onClick={(event) => handleOpenPopover(event, row)}
                                
                                
                              >
                                <FcInfo /> 
                              </IconButton>
                            ) }
                          
                          </Box>
                        
                        
                        
                        
                       
                        </TableCell>

                        <TableCell sx={{ border: '1px solid #ccc', padding: '5px', textAlign: 'center'}}>
                          <Box>
                            {(row?.totalAssignment_present || 0) != 0 ? (row?.totalAssignment_present.toFixed(1)) : "-"}

                            {isNaN(row?.totalAssignment_present) ? "" :
                              (
                                <IconButton
                                  sx={{ height: 30, width: 30 }}
                                  onClick={(event) => handleOpenReportPopover(event, row)}


                                >
                                  <FcInfo />
                                </IconButton>
                              )}
                          </Box>
                        </TableCell>

                        <TableCell sx={{border: '1px solid #ccc', padding: '5px', textAlign: 'center'}}>
                          <Box>
                            {(row?.assessment_company || 0) != 0 ? (
                              <>
                                {(parseFloat(row?.assessment_company_total)).toFixed(1)}
                                <Link
                                  to={`/internship-evaluation?req_id=${row.req_id}`}
                                  target="_blank"
                                  style={{ textDecoration: 'none', marginLeft: '4px' }}
                                >
                                  <IconButton
                                    sx={{ height: 30, width: 30 }}
                                    title="ดูรายงานประเมิน"
                                  >
                                    <FcInfo />
                                  </IconButton>
                                </Link>
                              </>
                            ) : (
                              <IconButton onClick={() => handleOpenSingleModal(row)}>
                                <AddIcon sx={{ fontSize: 15 }} />
                              </IconButton>
                            )}
                          </Box>
                        </TableCell>

                      

                        

                        <TableCell sx={{ backgroundColor: '#eceff1' , border: '1px solid #ccc', padding: '5px', textAlign: 'center'}}>
                          <Box sx={{ fontWeight: 'bold' }}>
                            {
                              [row?.logbookscore, row?.internDetailMark, row?.totalAssignment_visit, row?.totalAssignment_present, row?.assessment_company_total]
                                .map(parseFloat) // Convert all values to float
                                .filter(value => !isNaN(value)) // Keep only values that are not NaN
                                .reduce((acc, value) => acc + value, 0) // Sum up all non-NaN values
                                .toFixed(1) // Round to 1 decimal places
                            }
                           </Box>
                        </TableCell>

                      </TableRow>
                    );
                  })}

                {/* Show "no data" message when no items found */}
                {rowsFilter.length === 0 && (
                  <TableRow>
                    <TableCell 
                      colSpan={headCells.length} 
                      sx={{ 
                        textAlign: 'center', 
                        padding: '40px 20px',
                        fontSize: '16px',
                        color: '#666',
                        fontFamily: 'TH Sarabun New, Arial, sans-serif'
                      }}
                    >
                      ไม่มีรายการ
                    </TableCell>
                  </TableRow>
                )}

                {/* {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: (dense ? 33 : 53) * emptyRows,
                    }}
                  >
                    <TableCell colSpan={6} />
                  </TableRow>
                )} */}

              
                  
              </TableBody>

                

            </Table>
          </TableContainer>
          
          
        </Paper>

      <Modal
        open={openModal1}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400, // Adjust the width as needed
            bgcolor: 'rgba(255, 255, 255, 1)', // Making the background semi-transparent
            boxShadow: 80,
            p: 3,
            outline: 'none' // Removes the focus outline for a cleaner look
          }}
        >
          <Typography sx={{
            fontSize: 20,
            fontWeight: 'bold',
            textAlign: 'left',
            paddingBottom: '10px'

          }}>
            <Box sx={{ fontWeight: 'bold' }}>
              แบบประเมินนิสิตสหกิจศึกษาจากพี่เลี้ยง
            </Box>
            <Typography sx={{
              fontSize: 15,
              fontWeight: 'bold',
              textAlign: 'left',

            }}>
              <Typography sx={{
                fontSize: 15,
                fontWeight: 'bold',
                textAlign: 'left',
              }}>
                ReqID:
                {selectedItemId?.row?.req_id}
              </Typography>
              {selectedItemId?.row?.name.split(",")[0]}
            </Typography>
            <Typography sx={{
              fontSize: 15,
              fontWeight: 'bold',
              textAlign: 'left',
              paddingBottom: '10px'
            }}>
              {selectedItemId?.row?.name.split(",")[1]}
            </Typography>
            <Typography sx={{
              fontSize: 15,
              fontWeight: 'bold',
              textAlign: 'left',
              paddingBottom: '10px'
            }}>
              {selectedItemId?.row?.company}
            </Typography>
          </Typography>

          <form onSubmit={handleSubmit1} style={{ /* Style your form container */ }}>
            <FormControl fullWidth>
              {/* Form fields */}
              <Grid item xs={2} md={2}>
                <Box>
                  <TextField
                    type="number"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    paddingBottom="20px" label="คะแนนรวมจากพี่เลี้ยง " required onChange={(e) => setTotalScore(e.target.value)} />
                  <TextField
                    type="number"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    defaultValue={200}
                    paddingBottom="20px" label="คะแนนเต็ม " required onChange={(e) => setTotal(e.target.value)} />
                </Box>
              </Grid>

              <TextField paddingBottom="20px" label="ผู้ประเมิน" required onChange={(e) => setEvaluator(e.target.value)} />
              <TextField multiline maxRows={3}
                paddingBottom="20px" label="จุดเด่นของนิสิต/Strength" onChange={(e) => setInternCharacteristics(e.target.value)} />
              <TextField paddingBottom="20px" label="ข้อควรปรับปรุงของนิสิต/Improvement" onChange={(e) => setKnowledgeBeforeInternship(e.target.value)} />

              <TextField paddingBottom="20px" label="ข้อคิดเห็นเพิ่มเติม" onChange={(e) => setInternRecommendations(e.target.value)} />
              <TextField paddingBottom="20px" label="วัน/เวลาประเมิน (รูปแบบ: YYYY-MM-DD 09:00:00)" defaultValue={formatDateToYYYYMMDDHHMMSS(new Date())}
                onChange={(e) => setEvaluationDateTime(e.target.value)

                } />
              {/* Add more fields as needed */}
            </FormControl>
            <Button type="submit">Submit</Button>
            <Button onClick={handleCloseModal}>Close</Button>
          </form>
        </Box>
      </Modal>

      <Modal
        open={openModal2}
        onClose={handleCloseModal2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400, // Adjust the width as needed
            bgcolor: 'rgba(255, 255, 255, 1)', // Making the background semi-transparent
            boxShadow: 80,
            p: 3,
            outline: 'none' // Removes the focus outline for a cleaner look
          }}
        >
          <Typography sx={{
            fontSize: 20,
            fontWeight: 'bold',
            textAlign: 'left',
            paddingBottom: '10px'

          }}>
            <Box sx={{ fontWeight: 'bold' }}>
              แบบประเมิน <br />
              รายงานสหกิจศึกษาจากพี่เลี้ยง
            </Box>
            <Typography sx={{
              fontSize: 15,
              fontWeight: 'bold',
              textAlign: 'left',

            }}>
              <Typography sx={{
                fontSize: 15,
                fontWeight: 'bold',
                textAlign: 'left',
              }}>
                ReqID:
                {selectedItemId2?.row?.req_id}
              </Typography>
              {selectedItemId2?.row?.name.split(",")[0]}
            </Typography>
            <Typography sx={{
              fontSize: 15,
              fontWeight: 'bold',
              textAlign: 'left',
              paddingBottom: '10px'
            }}>
              {selectedItemId2?.row?.name.split(",")[1]}
            </Typography>
            <Typography sx={{
              fontSize: 15,
              fontWeight: 'bold',
              textAlign: 'left',
              paddingBottom: '10px'
            }}>
              {selectedItemId2?.row?.company}
            </Typography>
          </Typography>

          <form onSubmit={handleSubmit2} style={{ /* Style your form container */ }}>
            <FormControl fullWidth>
              {/* Form fields */}
              <Grid item xs={2} md={2}>
                <Box>
                  <TextField
                    type="number"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    paddingBottom="20px" label="คะแนนรวมจากพี่เลี้ยง " required onChange={(e) => setTotalScore(e.target.value)} />
                  <TextField
                    type="number"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    defaultValue={100}
                    paddingBottom="20px" label="คะแนนเต็ม " required onChange={(e) => setTotal2(e.target.value)} />
                </Box>
              </Grid>

              <TextField paddingBottom="20px" label="ผู้ประเมิน" required onChange={(e) => setEvaluator(e.target.value)} />
              <TextField paddingBottom="20px" label="ข้อคิดเห็นเพิ่มเติม" onChange={(e) => setInternRecommendations(e.target.value)} />
              <TextField paddingBottom="20px" label="วัน/เวลาประเมิน (รูปแบบ: YYYY-MM-DD 09:00:00)" defaultValue={formatDateToYYYYMMDDHHMMSS(new Date())}
                onChange={(e) => setEvaluationDateTime(e.target.value)

                } />
              {/* Add more fields as needed */}
            </FormControl>
            <Button type="submit">Submit</Button>
            <Button onClick={handleCloseModal2}>Close</Button>
          </form>
        </Box>
      </Modal>


      {/* Bulk Input Modal */}
      <BulkInputModal
        open={openBulkModal}
        onClose={handleCloseBulkModal}
        inputType={bulkInputType}
        tableData={tableData}
        onRefresh={onRefresh} // ส่ง callback สำหรับ refresh ข้อมูล
      />

      {/* Single Evaluation Modal
      <SingleEvaluationModal
        open={openSingleModal}
        onClose={handleCloseSingleModal}
        reqId={selectedStudentData?.req_id}
        studentName={selectedStudentData?.name || ''}
        onRefresh={onRefresh} // ส่ง callback สำหรับ refresh ข้อมูล
      /> */}
        
      
      
      
    </>
  );
}
